// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__cusLj","heading":"Projects_heading__jwMMR","projects_grid":"Projects_projects_grid__4mGch"};